import * as types from '../mutation-types'
import { UTILS } from '../../utils'
import { API } from '../../api'
import { LABEL_DATA_MANAGER } from '../../data'
import msg_srv from '../../api/msg_srv'

export default {
    namespaced: true,
    state: {
        gotLabelList: false,
        myLabelData: [],
        commonLabelData: {},
        totalLabelListData: [],
        filterLabelListData: [],
        selectedLabelChanged: false,
        selectedLabelData: [],
        selectedLabelString: '',
        selectedLabelId: '',
        confirmedLabelData: [],
        searchedLabelData: [],
        searchedLabelString: '',
        remarkStringData: '',
        curAddIndex: 0,
        curAddList: [],
    },
    getters: {},
    mutations: {
    },
    actions: {
        initLabelList({ state }, params) {
            if(state.gotLabelList) { 
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
                return; 
            }
            API.getLabelList({}, function(data) {
                state.gotLabelList = true;
                console.log('获取我的标签成功:::::::', data);
                state.myLabelData = LABEL_DATA_MANAGER.getMyLabelDataListByData(data.my);
                var commonData = LABEL_DATA_MANAGER.getCommonLabelDataListByData(data.common);
                state.commonLabelData = commonData.data;
                state.totalLabelListData = state.myLabelData.concat(commonData.list);
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            });
        },
        initSelectedLabelFromDetail({ state }, detailInfo) {
            console.log('initSelectedLabelFromDetail----', detailInfo.label, detailInfo.remark);
            state.confirmedLabelData = LABEL_DATA_MANAGER.getConfirmLabelDataByLabelId(state.totalLabelListData, detailInfo.label);
            state.remarkStringData = detailInfo.remark;
            var resultData = LABEL_DATA_MANAGER.getSelectedLabelParamsByList(state.confirmedLabelData);
            state.selectedLabelString = resultData.string;
            state.selectedLabelId = resultData.id;
        },
        updateComfirmedSelectedLabel({state }) {
            console.log('updateComfirmedSelectedLabel-----', state.confirmedLabelData)
            if(state.confirmedLabelData.length == 0) { return; }
            var newList = [];
            state.confirmedLabelData.forEach(element => {
                if(element.type == 'my') {
                    state.myLabelData = LABEL_DATA_MANAGER.setMyLabelDataChoosedStatus(state.myLabelData, element, true);
                }else if(element.type == 'common') {
                    state.commonLabelData[element.f_category] = LABEL_DATA_MANAGER.setCommonLabelDataChoosedStatus(state.commonLabelData, element, true);
                }
                newList.push(element);
            });
            state.selectedLabelData = [].concat(newList);
        },
        updateLabelDataChoosedStatus({state}, curData) {
            var resultList = [];
            switch(curData.type) {
                case 'my':
                    resultList = LABEL_DATA_MANAGER.updateMyLabelDataChoosedStatus(state.myLabelData, curData);
                    state.myLabelData = [].concat(resultList);
                    break;
                case 'common':
                    resultList = LABEL_DATA_MANAGER.updateCommonLabelDataChoosedStatus(state.commonLabelData, curData);
                    state.commonLabelData[curData.f_category] = [].concat(resultList);
                    break;
                default:
                    break;
            }
        },
        updateSelectedLabelData({state}, curData) {
            state.selectedLabelChanged = true;
            if(curData.choosed) {
                state.selectedLabelData.push(curData);
            }else {
                state.selectedLabelData = LABEL_DATA_MANAGER.deleteSelectedDataByData(state.selectedLabelData, curData);
            }
        },
        getFilterLabelList({state}, inputValue) {
            var listData = [].concat(state.totalLabelListData);
            state.filterLabelListData.splice(0);
            
            inputValue = inputValue.trim();
            if(inputValue == '') { return; }
            state.filterLabelListData = listData.filter(data => {
                var selectedStatus = LABEL_DATA_MANAGER.checkSelectedLabelDataStatus(state.selectedLabelData, data.id);
                var textStatus = data.f_title.toLowerCase().indexOf(inputValue.toLowerCase()) === 0;
                return !selectedStatus && textStatus;
            });
            console.log('getFilterLabelList-----', inputValue, state.filterLabelListData);
        },
        addSelectedLabelData({dispatch, state}, params) {
            state.selectedLabelChanged = true;
            var newData = {
                'type': 'new',
                "id": params.id, 
                'f_title': params.title,
                'choosed': true
            };
            state.selectedLabelData.push(newData);
            state.filterLabelListData.splice(0);
            dispatch('label/resetSelectedLabelDataDeleteStatus', null, {root: true})
        },
        deleteSelectedLabelData({dispatch, state}) {
            var curList = [].concat(state.selectedLabelData),
                len = curList.length;
            if(len == 0) { return; }
            
            var curData = curList[len-1];
            if(!curData) { return; }
            
            console.log('deleteSelectedLabelData-----', curData)
            state.selectedLabelChanged = true;
            if(!curData.canDelete) {
                curList[len-1].canDelete = true;
                state.selectedLabelData = [].concat(curList);
            }else {
                curList[len-1].canDelete = false;
                curList.splice(len-1, 1);
                state.selectedLabelData = [].concat(curList);
                dispatch('label/updateLabelDataChoosedStatus', curData, {root: true})
            }
        },
        resetSelectedLabelDataDeleteStatus({state}) {
            state.selectedLabelData.forEach((element, index) => {
                state.selectedLabelData[index].canDelete = false;
            });
        },
        saveSelectedLabelData({ dispatch, state}, params) {
            state.curAddList = state.selectedLabelData.filter(data => data.type == 'new');
            // 更新数据
            var resultData = LABEL_DATA_MANAGER.getSelectedLabelParamsByList(state.selectedLabelData);
            state.selectedLabelString = resultData.string;
            state.selectedLabelId = resultData.id;
            state.confirmedLabelData = state.selectedLabelData;
            state.filterLabelListData.splice(0);
            
            console.log('saveSelectedLabelData-------', state.selectedLabelData, state.curAddList);
            if(state.curAddList.length > 0) {
                dispatch('label/addLabel', params, {root: true});
            }else {
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            }
        },
        saveSearchedLabelData({ state }) {
            state.searchedLabelData = state.selectedLabelData;
            state.searchedLabelString = LABEL_DATA_MANAGER.getSearchedLabelStringByList(state.selectedLabelData);
        },
        addLabel({ dispatch, state }, params) {
            var curData = state.curAddList[state.curAddIndex];
            if(!curData) { return; }
            API.addLabel({
                f_title: curData.f_title
            }, function(data) {
                console.log('添加标签成功::::', data, curData.f_title, state.curAddIndex);
                var newData = LABEL_DATA_MANAGER.getMyLabelDataByData(data);
                state.myLabelData.push(newData);
                state.totalLabelListData.push(newData);
                state.selectedLabelData = LABEL_DATA_MANAGER.updateSelectedLabelDataByData(state.selectedLabelData, newData);
                // 更新数据
                var resultData = LABEL_DATA_MANAGER.getSelectedLabelParamsByList(state.selectedLabelData);
                state.selectedLabelString = resultData.string;
                state.selectedLabelId = resultData.id;
                state.confirmedLabelData = state.selectedLabelData;
                state.filterLabelListData.splice(0);
    
                // 轮询单个添加标签
                state.curAddIndex++;
                if(state.curAddIndex < state.curAddList.length) {
                    dispatch('label/addLabel', params, {root: true});
                }else {
                    if(params && params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }
            })
        },
        updateLabel({ state }, params) {
            API.updateLabel({
                id: params.id,
                f_title: params.newTitle.toString()
            }, function(data) {
                if(data.ret) {
                    console.log('修改标签成功:::::::')
                    state.myLabelData = LABEL_DATA_MANAGER.updateMyLabelDataByParams(state.myLabelData, params)
                    state.totalLabelListData = LABEL_DATA_MANAGER.updateMyLabelDataByParams(state.totalLabelListData, params);
                    
                    state.selectedLabelChanged = true;
                    state.selectedLabelData = LABEL_DATA_MANAGER.updateMyLabelDataByParams(state.selectedLabelData, params)
                    state.confirmedLabelData = state.selectedLabelData;
                    // 更新数据
                    var resultData = LABEL_DATA_MANAGER.getSelectedLabelParamsByList(state.selectedLabelData);
                    state.selectedLabelString = resultData.string;
                    state.selectedLabelId = resultData.id;
                    
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }
            }, function(data) {
                console.log('data-----', data)
                AppFate.$toast(msg_srv[data.status_code]);
            })
        },
        deleteLabel({ state }, params) {
            API.deleteLabel({
                id: params.id
            },  function(data) {
                if(data.ret) {
                    console.log('删除标签成功:::::::')
                    state.myLabelData = LABEL_DATA_MANAGER.deleteMyLabelDataById(state.myLabelData, params.id)
                    state.totalLabelListData = LABEL_DATA_MANAGER.deleteMyLabelDataById(state.totalLabelListData, params.id);

                    state.selectedLabelChanged = true;
                    state.selectedLabelData = LABEL_DATA_MANAGER.deleteMyLabelDataById(state.selectedLabelData, params.id)
                    state.confirmedLabelData = state.selectedLabelData;
                    // 更新数据
                    var resultData = LABEL_DATA_MANAGER.getSelectedLabelParamsByList(state.selectedLabelData);
                    state.selectedLabelString = resultData.string;
                    state.selectedLabelId = resultData.id;

                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }
            })
        },
        resetSelectedData({ state }) {
            state.myLabelData = LABEL_DATA_MANAGER.resetMyLabelDataChoosedStatus(state.myLabelData);
            state.commonLabelData = LABEL_DATA_MANAGER.resetCommonLabelDataChoosedStatus(state.commonLabelData);
            state.selectedLabelData = [];
            state.curAddIndex = 0;
            state.curAddList = [];
        },
        resetData({ state }) {    
            state.myLabelData = LABEL_DATA_MANAGER.resetMyLabelDataChoosedStatus(state.myLabelData);
            state.commonLabelData = LABEL_DATA_MANAGER.resetCommonLabelDataChoosedStatus(state.commonLabelData);
            state.selectedLabelData = [];
            state.curAddIndex = 0;
            state.curAddList = [];

            state.filterLabelListData = [];
            state.selectedLabelChanged = false;
            state.selectedLabelString = '';
            state.selectedLabelId = '';
            state.confirmedLabelData = [];
            state.searchedLabelData = [];
            state.searchedLabelString = '';
            state.remarkStringData = '';
        }
    }
}